<div class="layout">
  <app-header></app-header>

  <app-navbar></app-navbar>

  <div class="layout__content">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
